import React from "react";
import {format, isValid} from 'date-fns';
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import config from '../../config';
import { FormControl, FilledInput, InputAdornment,IconButton, InputLabel } from '@mui/material';
import { CalendarMonthRounded, Clear } from '@mui/icons-material';

const styleField = {
    width: '100%',
  };

const CustomDatePicker = ({ onChange, open, setOpen, state, setState }) => {
  const startDate = state[0].startDate ? format(state[0].startDate, "yyyy/MM/dd") : "";
  const endDate = (isValid(state[0].endDate)) ? format(state[0].endDate, "yyyy/MM/dd") :"";
  const rangeData = startDate +" ~ "+ endDate;

  const handleOnChange = (ranges) => {
    const { selection } = ranges;
    onChange(selection);
    setState([selection]);
  };

  const handleButton = () => {
    if (open === false) {
      state[0].startDate = null;
      state[0].endDate = new Date("");
    }
    setOpen(!open);
  };

  const handleClear = () => {
    setState([{startDate: null, endDate: null, key: "selection"}])
  }

  return (
    <>
      {state[0].startDate !== "" && state[0].endDate !== "" &&
        (<FormControl style={styleField} >
          <InputLabel >Select date range</InputLabel>
          <FilledInput
            sx={{ height: '56px' }}
            id="filled-adornment-password"
            color={config.heavyColor}
            type={'text'}
            value={rangeData }
            endAdornment={
              <InputAdornment position="start">
                <IconButton
                  onClick={handleClear}
                  edge="end"
                >
                 <Clear />
                </IconButton>
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleButton}
                  edge="end"
                >
                 <CalendarMonthRounded />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>)
      }
      {open && (
        <DateRange
          onChange={handleOnChange}
          moveRangeOnFirstSelection={false}
          dateDisplayFormat="yyyy/MM/dd"
          ranges={state}
          retainEndDateOnFirstSelection={true}
          rangeColors={[config.heavyColor]}
        />
      )}
    </>
  );
};

export default CustomDatePicker;
